
export class DiscussionMessageModelBase {
    public Name: string;
    //public Children: Array<DiscussionMessageModelBase>;
    public Visible: boolean;

    constructor(name: string) {
        this.Name = name;
        //this.Children = children || [];
        this.Visible = true;
    }


    
}